import { Box, IconButton, Checkbox, FormControlLabel, TextField } from "@mui/material";
import React, { useState } from "react";
import { notify } from "react-notify-toast";
import { Document, Page } from "react-pdf";
import { API } from "../../API";
import { withRouter } from "react-router-dom";
import moment from "moment";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CircularProgress from '@mui/material/CircularProgress';

function SignContractContent(props) {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [isAccepting, setIsAcceptingContract] = useState(false)
  const [isSendContract, setIsSendContract] = useState(false)
  const [personEmail, setPersonEmail] = useState("")
  const [abn, setAbn] = useState("")
  const [scale, setScale] = useState(1.5)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleSignContract = () => {
    if (!abn || !validateABN(abn)) {
      notify.show("Please insert a valid company ABN", "error")
      return
    }
    if (isSendContract && !personEmail.trim()) {
      notify.show("Please enter an email", "error")
      return
    }

    if (isSendContract && !validateEmail(personEmail)) {
      notify.show("Please insert a valid email", "error")
      return
    }

    setIsAcceptingContract(true)

    const payload = {
      signedDate: moment().utc(),
      fundAbn: abn.trim()
    }

    if (isSendContract && personEmail) {
      payload.optionalReceiverEmail = personEmail
    }

    API.acceptContract(payload)
      .then((response) => {
        notify.show(response?.data?.data)

        API.getInstitutionDataById(props.user.institution_id || props.user.institution)
          .then((res) => {
            const inst = res?.data;
            props.updateInstInfo(inst);
            setIsAcceptingContract(false)
            props.history.push(props.user.role === "customer"? "/CollegeDashboard" : "/PersonnelDashboard")
          })
          .catch(err => {
            console.log('err', err)
          })
          .finally(() => {
            setIsAcceptingContract(false)
          })
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setIsAcceptingContract(false)
      })
  }

  const validateABN = (value) => {
    const regex = /^\d{11}$/;
    return regex.test(value)
  }

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };


  const handleZoomIn = () => {
    setScale(prevValue => prevValue + 0.25)
  };

  const handleZoomOut = () => {
    if (scale > 1.25) {
      setScale(prevValue => prevValue - 0.25)
    }
  };

  const handleFullscreen = () => {
    window.open(props.pdfFile, '_blank');
  };


  return (
    <div className="pdf-div">
      <Box sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '10px',
        '@media (max-width: 480px)': {
          display: "none"
          },
        }}>
        <IconButton onClick={handleZoomIn}>
          <ZoomInIcon />
        </IconButton>
        <IconButton onClick={handleZoomOut}>
          <ZoomOutIcon />
        </IconButton>
        <IconButton onClick={handleFullscreen}>
          <FullscreenIcon />
        </IconButton>
      </Box>
      <div className="row">
      <Box className="col-lg-12 col-xs-12" sx={{margin: 0, padding: 0, height: "700px", overflowY: "auto"}}>
        {
          pageNumber && numPages && (
            <p className="my-2">
              { `Page ${pageNumber} of ${numPages}`}
            </p>
          )
        }
        {
          !props.pdfFile && (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress />
            </Box>
          )
        }
        {
          props.pdfFile && (
            <Document file={props.pdfFile} onLoadSuccess={onDocumentLoadSuccess} loading="Loading Terms & Conditions...">
              {Array.apply(null, Array(numPages))
                .map((x, i) => i + 1)
                .map((page) => {
                  return (
                    <>
                      <Page
                        key={page}
                        pageNumber={page}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        size="A4"
                        scale={scale}
                      />
                      {
                        page === numPages && (
                          <Box 
                            sx={{
                              background: "white",
                              padding: "20px",
                              margin: "0 auto",
                              width: "60%",
                              marginBottom: "60px",
                              '@media (max-width: 480px)': {
                                width: '100%',
                                padding: "5px"
                              },
                            }}
                          >
                            <Box sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: "baseline",
                            }}>
                              <TextField
                                sx={{
                                  width: "30%",
                                  '@media (max-width: 480px)': {
                                    width: '50%',
                                  },
                                }}
                                id="outlined-basic"
                                label="Please insert your company ABN" variant="outlined"
                                size="small"
                                value={abn}
                                onChange={(e) => setAbn(e.target.value)}
                                inputProps={{ maxLength: 11 }}
                                helperText={abn && !validateABN(abn) ? <p className="text-danger">The ABN must be in 11 digits</p> : ""}
                              />
                            </Box>
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() => setIsSendContract(!isSendContract)}
                                  />
                                }
                                label="Send a copy of the contract to another person"
                                className="mt-2 my-0"
                              />
                              {
                                isSendContract && (
                                  <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: "baseline",
                                    marginBottom: "15px"
                                  }}>
                                    <TextField
                                      sx={{
                                        width: "30%",
                                        '@media (max-width: 480px)': {
                                          width: '50%',
                                        },
                                      }}
                                      id="outlined-basic"
                                      label="Email" variant="outlined"
                                      size="small"
                                      value={personEmail}
                                      onChange={(e) => setPersonEmail(e.target.value)}
                                    />
                                  </Box>
                                )
                              }
                            </div>
                            <ConfirmButton
                              onClick={handleSignContract}
                              className="mb-3"
                              disabled={!validateABN(abn)}
                            >
                              { isAccepting ? "Accepting..." : "Accept Terms and Conditions"}
                            </ConfirmButton>
                          </Box>
                        )
                      }
                    </>
                  );
                })}
            </Document>
          )
        }
        
      </Box>
      </div>
    </div>
  );
}

export default withRouter(SignContractContent);
